import { receivedServerError } from "../../Error/Actions";
import Utilities from "../../../Helpers/Utilities";
import Constants from "../../../AppConstants/Constants";
import { RECEIVED_CONFIG } from "../Constants";

export function loadConfig(cb) {
    return function(dispatch) {
        return fetch(Utilities.buildUrl("/clientappsettings.json", true), Constants.FETCH_REQUEST_CONFIG)
            .then(res => res.json())
            .then(config => {
                dispatch(receivedConfig(config));

                if (cb && typeof cb === "function") {
                    cb();
                }
            })
            .catch(error => {
                dispatch(receivedServerError(true, error.message));
                dispatch(receivedServerError(false));
            });
    };
}

function receivedConfig(data) {
    return {
        type: RECEIVED_CONFIG,
        payload: data
    };
}